import { createFileRoute } from '@tanstack/react-router';
import { CardLimitsPage } from '../components/pages/CardPage/CardLimitsPage';

export const Route = createFileRoute('/account/cards_/$cardId_/limits')({
  component: CardLimitsPage,
});
